export const METERS_PER_KM = 1_000
